export default __webpack_public_path__ + "static/media/51_desktop.7361c716.jpg";